import { useEffect, useState } from 'react';
import { useCoveoEngine } from 'lib/utils/coveo/SearchContext/CoveoEngineContext';
import { useSearch } from 'lib/utils/coveo/SearchContext/SearchContext';

export const useCoveoSearchSubscription = () => {
  const engine = useCoveoEngine();
  const { ContextResults, setContextResults } = useSearch();
  const [firstSearchExecuted, setFirstSearchExecuted] = useState(false);

  useEffect(() => {
    if (!engine) return;

    const unsubscribe = engine.subscribe(() => {
      setContextResults(engine.state.search);

      if (engine?.state?.search?.response && !firstSearchExecuted) {
        setFirstSearchExecuted(true);
      }
    });

    return () => unsubscribe();
  }, [engine, firstSearchExecuted, setContextResults]);

  return {
    ContextResults,
    firstSearchExecuted,
    setContextResults,
  };
};
